// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fe-3";
export var flatBottomCorners = "_fe-5";
export var productImage = "_fe-0";
export var quantityContainer = "_fe-2";
export var quantityHeader = "_fe-6";
export var tooltip = "_fe-1";
export var wrapAndEllipsesOverflow = "_fe-4";